// @flow

import * as React from 'react';
import { isTripUser } from '@ta/trips.trip-util';
import TripModalLink from '@ta/trips.trip-modal-links';

import { InteractionLogger } from '@ta/tracking.interactions';

type Props = {|
  trip: any,
  children: React.Node,
  className?: string,
|};

const LinkToTrip = ({ trip, className, children }: Props) => (
  <InteractionLogger>
    {logFeedClick => (
      <TripModalLink
        tripModalDescriptor={{
          isUser: isTripUser(trip),
          href: trip.route?.url,
          navigator: { id: trip.id, title: trip.title },
        }}
        onClick={e => {
          if (trip.registerClick) {
            trip.registerClick();
          }
          logFeedClick(e, 'feedClick');
          e.stopPropagation();
        }}
        className={className}
      >
        {children}
      </TripModalLink>
    )}
  </InteractionLogger>
);

export default LinkToTrip;
